import { useToast } from '@/hooks/useToast';
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider as LibraryToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast';
import { Icon } from '@/components/ui/icon';
import { CircleCheckBig, CircleX } from 'lucide-react';

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const { toasts } = useToast();

  return (
    <LibraryToastProvider>
      { children }
      { toasts.map(function ({
        id,
        title,
        description,
        action,
        variant,
        ...props
      }) {
        return (
          <Toast key={ id } variant={ variant } { ...props }>
            <div className="flex items-center gap-space-md">
              { variant === 'destructive'
                ? (
                  <Icon
                    lucideIcon={ CircleX }
                    className="text-icon-status-danger-default shrink-0"
                  />
                )
                : (
                  <Icon lucideIcon={ CircleCheckBig } className="shrink-0" />
                ) }
              <div className="grid">
                { title && <ToastTitle>{ title }</ToastTitle> }
                { description && (
                  <ToastDescription>{ description }</ToastDescription>
                ) }
              </div>
            </div>
            { action }
            <ToastClose />
          </Toast>
        );
      }) }
      <ToastViewport />
    </LibraryToastProvider>
  );
}
